import { create } from "zustand";

const host = process.env.REACT_APP_BACKEND_URL;
const funnelHost = process.env.REACT_APP_PEOPLE_URL + "/api";


// const host = "https://oiomni.com/api";
// const funnelHost = "http://people.oiomni.com:8001/api";
const bssp_host = 'https://sms.bulksmsserviceproviders.com/api/';

const token = localStorage.getItem("token");
const user_id = localStorage.getItem("user_id");
const auth_key = localStorage.getItem("auth_key");
const username = localStorage.getItem("username");
const length = localStorage.getItem("length");
const wa_authKey = localStorage.getItem("wa_auth_key");
const bssp_authKey = "46a57c629565ac350bae4264c3e82d9e"

const headers = {
	"headers": {
		"Authorization": `Bearer ${token}`,
		"Access-Control-Allow-Origin": "*",
		"Content-Type": "application/json",
		"Accept": "application/json",
		"mode": "no-cors",
	},
};

const noAuth = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('auth_key');
    localStorage.removeItem('user_id');
    localStorage.removeItem('username');
    localStorage.removeItem('length');
    localStorage.removeItem('wa_auth_key');
    window.location.href = 'https://www.tickmaker.io/home';
};


const useGlobalStore = create((set) => ({
	token: token,
	user_id: user_id,
	auth_key: auth_key,
	username: username,
	length: length,
	headers: headers,
	host: host,
	funnelHost: funnelHost,
	bssp_host: bssp_host,
	noAuth: noAuth,
	wa_authKey: wa_authKey,
	bssp_authKey: bssp_authKey,
}));

export default useGlobalStore;
